import { media } from 'constants/media/media'
import styled, { css } from 'styled-components'

interface ButtonProps {
	active?: boolean
	green?: boolean
	mb?: string
	allergensFilter: boolean
	isLastChild?: boolean
}

export const FilterButton = styled.button<ButtonProps>`
	position: relative;
	display: block;
	height: 3.1rem;
	width: 100%;
	max-width: 100%;
	padding: 0 1.7rem;
	margin-bottom: ${({ mb }) => mb || ''};
	color: ${({ theme }) => theme.colors.textDark};
	background-color: ${({ isLastChild, theme, active }) => (isLastChild && active ? theme.colors.anchorBlue : '#fff')}};
	font-family: ${({ theme }) => theme.fonts.fontFamily};
	font-size: 1.6rem;
	font-weight: 700;
	line-height: 3.1rem;
	border-radius: 6rem;
	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	cursor: pointer;
	transition-property: color, background-color, border, transform, opacity;
	transition-duration: 200ms;

	&:hover {
		background-color: ${({ theme }) => theme.colors.grayLighter};
	}

	&:after {
		content: '✕';
		position: absolute;
		top: 0;
		right: 1.5rem;
		font-size: 1.4rem;
		font-weight: 400;
		opacity: 0;
		transition: opacity 200ms;
	}

	${({ active, green, isLastChild, theme, allergensFilter }) =>
		active && green
			? css`
					background-color: ${theme.colors.green};
					color: #fff;

					&:hover {
						background-color: ${theme.colors.greenDark};
					}

					&:after {
						opacity: 1;
					}
			  `
			: active && allergensFilter
			? css`
					background-color: ${theme.colors.secondary};
					color: #fff;
					text-decoration: line-through;
					transition: line-through 0.3s ease-in-out;

					&:hover {
						background-color: ${theme.colors.secondaryDark};
					}

					&:after {
						opacity: 1;
					}
			  `
			: active &&
			  css`
					background-color: ${theme.colors.primary};
					color: #fff;

					&:hover {
						background-color: ${theme.colors.primaryDark};
					}

					&:after {
						opacity: ${isLastChild ? 0 : 1};
					}
			  `}
`

//@ts-ignore
export const FilterButtonHideHandheld = styled(FilterButton)<ButtonProps>`
	${media.tabletAndMobileOnly`
		display: none;
	`}
`
